<template>
  <div>
    <b-row>
      <b-col
        lg="11"
        md="11"
        sm="12"
      >
        <b-link
          style="font-size: 20px; color: #fff;"
          to="/project"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="20"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80;"> โครงการ: </span>{{ title }}
        </b-link>
      </b-col>
      <b-col
        lg="1"
        md="1"
        sm="12"
        class="text-sm-right"
      >
        <b-badge
          style="font-size: 14px; margin-top: 10px;"
          :variant="guarantee_status[1][status]"
        >
          {{ guarantee_status[0][status] }}
        </b-badge>
      </b-col>
    </b-row>
    <b-tabs class="mt-1">
      <b-tab active>
        <template #title>
          <feather-icon
            icon="ToolIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">อุปกรณ์</span>
        </template>
        <b-tabs
          v-model="tabIndex"
          vertical
          content-class="col-12 col-md-10 mt-1 mt-md-0"
          pills
          nav-wrapper-class="col-md-2 col-12"
          nav-class="nav-left"
        >

          <b-tab
            v-for="(item, index) in items"
            :key="'location'+index"
            @click="$refs.sumEquipment[index].getSumEquipment(item.location_id)"
          >
            <!-- title -->
            <template
              #title
            >
              <feather-icon
                icon="FolderIcon"
                size="18"
                class="mr-50"
              />
              <span
                v-if="item.location_name"
                class="font-weight-bold"
              >{{ item.location_name }}</span>
              <span
                v-else
                class="font-weight-bold"
              >จุดที่ {{ index+1 }}</span>
            </template>

            <sum-equipment
              ref="sumEquipment"
              :project-data="item"
              @fetch="getTableLocation()"
            />
          </b-tab>
          <template #tabs-end>
            <b-nav-item
              role="presentation"
              @click.prevent="newTab"
            >
              <feather-icon
                icon="PlusIcon"
                size="18"
              />
            </b-nav-item>
          </template>
        <!--/ general tab -->

        </b-tabs>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon
            icon="LinkIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Solutions</span>
        </template>
        <b-tabs
          vertical
          content-class="col-12 col-md-9 mt-1 mt-md-0"
          pills
          nav-wrapper-class="col-md-3 col-12"
          nav-class="nav-left"
        >
          <!-- general tab -->
          <b-tab
            v-for="(item, index) in items"
            :key="index"
            @click="$refs.sumSolution[index].getSumSolution(item.location_id)"
          >
            <!-- title -->
            <template #title>
              <feather-icon
                icon="FolderIcon"
                size="18"
                class="mr-50"
              />
              <span class="font-weight-bold">{{ item.location_name }}</span>
            </template>

            <sum-solution
              ref="sumSolution"
              :project-data="item"
              @fetch="getTableLocation()"
            />
          </b-tab>
        <!--/ general tab -->

        </b-tabs>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import {
  BTabs, BTab, BNavItem, BLink, BCol, BRow, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import SumEquipment from './SumEquipment.vue'
import SumSolution from './SumSolution.vue'

export default {
  components: {
    BTabs,
    BTab,
    BNavItem,
    SumEquipment,
    SumSolution,
    BLink,
    BCol,
    BRow,
    BBadge,
  },
  data() {
    return {
      tabIndex: 0,
      tabCounter: 1,
      totalRows: 1,
      tabs: [1],
      title: '',
      status: '',
      guarantee_status: [{
        0: 'หมดค้ำ', 1: 'อยู่ในค้ำ', 2: 'หมดค้ำ',
      },
      {
        0: 'light-warning', 1: 'light-info', 2: 'light-warning',
      }],
      items: [],
      itemsAll: {
        pj_code: this.$route.query.pj_code,
        location_id: 0,
        location_name: 'ทั้งหมด',
        guarantee_status: '',
        pj_name: '',
        road_name: '',
        deptname: '',
        deptid: '',
      },
    }
  },
  mounted() {
    this.getTableLocation()
  },
  methods: {
    getTableLocation() {
      axios
        .post('/locationMenu', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.itemsAll.deptname = response.data[0].deptname
          this.itemsAll.deptid = response.data[0].deptid
          this.itemsAll.road_name = response.data[0].road_name
          this.items = response.data
          if (this.items.length > 1) {
            this.items.splice(0, 0, this.itemsAll)
          }
          this.status = response.data[0].guarantee_status
          this.title = response.data[0].pj_name
          if (this.items.length > 1) {
            this.title = response.data[1].pj_name
          }
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkRoadID() {
    },
    newTab() {
      axios
        .post('/checkRoadID', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.$swal({
            title: '<span style="color:#000000">ต้องการเพิ่มจุดติดตั้งหรือไม่</span>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(async result => {
            if (result.value) {
              try {
                await axios
                  .post('/addELocation', {
                    pj_code: this.$route.query.pj_code,
                    road_name: response.data[0].wayname,
                    road_id: response.data[0].wayid,
                  })
                this.$swal({
                  icon: 'success',
                  title: '<span style="color:#000000">เพิ่มสำเร็จ</span>',
                  // text: 'Deleted successfully.',
                  showConfirmButton: false,
                  timer: 1000,
                })
                this.getTableLocation()
              } catch (error) {
                this.$swal({
                  title: 'Error!',
                  text: 'กดเพื่อดำเนินการต่อ!',
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              }
            }
          })
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
